import { handleRequest } from '_services';
import { normalize } from 'normalizr';
import {
    federalReviewMsgsSchema,
    masterDataSchema,
    notesPendingActionSchema,
    notesRequiringApprovalSchema,
    pndueSchema,
    dcdueSchema,
    specProgReqMsgsSchema,
    dashboardSchema,
    patientsSchema,
    notesSchema,
    fotoEpisodesSchema,
    alSchema,
    pdfSchema,
    mcDiaryItemsSchema
} from '_services/_schemas';
import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.js';

export const userService = {
    login,
    selectCompany,
    logout,
    test,
    saveSession,
    loadSession,
    cetsPunchIn,
};

function login(username) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username })
    };

    return handleRequest(process.env.REACT_APP_API_URI + '/users/authenticate', requestOptions, true)
        .then(data => {
            var parsedJwt;

            try {
                parsedJwt = JSON.parse(atob(data.token.split('.')[1]));
            } catch (e) {
                parsedJwt = null;
            }

            // store user details and jwt token in local storage to keep user logged in between page refreshes
            if (parsedJwt != null) {
                var user = {
                    urid: parsedJwt.ptero_urid,
                    firstname: parsedJwt.ptero_firstname,
                    lastname: parsedJwt.ptero_lastname,
                    sessionId: parsedJwt.ptero_sessionid,
                    cmAccess: parsedJwt.ptero_cmaccess,
                    isCetsPunchedIn: parsedJwt.ptero_cets_punched_in,
                    isPreviousDayAssigned: parsedJwt.ptero_ispreviousdayassigned,
                    IsPreviousDay2Assigned: parsedJwt.ptero_ispreviousday2assigned,
                    IsDepartmentCetsHardStop: parsedJwt.ptero_isdepartmentcetshardstop,
                    IsUserExempt: parsedJwt.ptero_isuserexempt
                };

                let loginTime = localStorage.getItem('loginTime') ?? undefined;
                var compareDateTime = new Date();
                compareDateTime.setHours(compareDateTime.getHours() - 12);
                if (loginTime) {
                    if (new Date(loginTime) <= compareDateTime) {
                        localStorage.setItem('loginTime', undefined);
                        window.location.reload();
                    }
                } else {
                    localStorage.setItem('loginTime', new Date());
                }
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem('pterotoken', data.token);
            }
            else
                localStorage.removeItem('user');

            return data;
        });
}

function selectCompany(companyId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '' + companyId
    };

    return handleRequest(process.env.REACT_APP_API_URI + '/users/selectcompany', requestOptions, true)
        .then(data => {
            var parsedJwt = {};
            var user = {};

            try {
                parsedJwt = JSON.parse(atob(data.token.split('.')[1]));
            } catch (e) {
                parsedJwt = null;
            }

            // store user details and jwt token in local storage to keep user logged in between page refreshes
            if (parsedJwt != null) {
                user = {
                    urid: parsedJwt.ptero_urid,
                    urno: parseInt(parsedJwt.ptero_urno),
                    thno: parseInt(parsedJwt.ptero_thno),
                    firstname: parsedJwt.ptero_firstname,
                    lastname: parsedJwt.ptero_lastname,
                    sessionId: parsedJwt.ptero_sessionid,
                    islicensed: (parsedJwt.ptero_islicensed === 'True'),
                    isRtmAdmin: (parsedJwt.ptero_isrtmadmin === 'True'),
                    isAide: (parsedJwt.ptero_isaide === 'True'),
                    isStudent: (parsedJwt.ptero_isstudent === 'True'),
                    clinicalURID: parsedJwt.ptero_clinicalurid,
                    isGraduate: (parsedJwt.ptero_isgraduate === 'True'),
                    isAssistant: (parsedJwt.ptero_isassistant === 'True'),
                    companyId: parseInt(parsedJwt.ptero_companyid),
                    company: parsedJwt.ptero_company,
                    cmAccess: (parsedJwt.ptero_cmaccess === 'True'),
                    isCetsPunchedIn: (parsedJwt.ptero_cets_punched_in === 'True'),
                    isPreviousDayAssigned: parsedJwt.ptero_ispreviousdayassigned,
                    IsPreviousDay2Assigned: parsedJwt.ptero_ispreviousday2assigned,
                    IsDepartmentCetsHardStop: parsedJwt.ptero_isdepartmentcetshardstop,
                    IsUserExempt: parsedJwt.ptero_isuserexempt

                };


                localStorage.setItem(`user_${companyId}`, JSON.stringify(user));
                localStorage.setItem(`pterotoken_${companyId}`, data.token);
                localStorage.setItem(`pterorefreshtoken_${companyId}`, data.refreshToken);
                sessionStorage.setItem('companyId', companyId);
            }
            else{

                localStorage.removeItem('user');
            }
                

            return user;
        });
}


function logout() {
    // remove our items from local storage - also it logged out 
    localStorage.clear();
}



function test() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return handleRequest(process.env.REACT_APP_API_URI + '/users/test', requestOptions, true);
}

async function saveSession(sessionData) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(sessionData)
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/usersessions/savesession', requestOptions, true);
}


async function loadSession() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/usersessions/loadsession', requestOptions, true)
        .then(data => {
            var flat = {
                masterData: normalize(data.masterData, masterDataSchema),
                notesRequiringApproval: normalize(data.notesRequiringApproval, notesRequiringApprovalSchema),
                notesPendingAction: normalize(data.notesPendingAction, notesPendingActionSchema),
                pndue: normalize(data.pndue, pndueSchema),
                dcdue: normalize(data.dcdue, dcdueSchema),
                specProgReqMsgs: normalize(data.specProgReqMsgs, specProgReqMsgsSchema),
                federalReviewMsgs: normalize(data.federalReviewMsgs, federalReviewMsgsSchema),
                mcDiaryItems: normalize(data.mcDiaryItems, mcDiaryItemsSchema),
                schedule: normalize(data.schedule, dashboardSchema),
                outstandingNotes: normalize(data.outstandingNotes, dashboardSchema),
                patientsContainer: normalize(data.patientsContainer, patientsSchema),
                fotoEpisodes: normalize(data.fotoEpisodes, fotoEpisodesSchema),
                notesContainer: normalize(data.notesContainer, notesSchema),
                alContainer: normalize(data.alContainer, alSchema),
                pdfsContainer: normalize(data.pdfsContainer, pdfSchema),
                ui: data.ui,
            }

            return flat;
        }).then(async (flat) => {
            if (flat.pdfsContainer.entities.pdfs) {
                await Promise.all(Object.keys(flat.pdfsContainer.entities.pdfs)
                    .map(async (id) => {
                        var binData = convertBase64ToBinaryArray(flat.pdfsContainer.entities.pdfs[id].pdfData);
                        flat.pdfsContainer.entities.pdfs[id].pdfData = binData;
                        flat.pdfsContainer.entities.pdfs[id].numPages = await getNumPages(binData);
                    })
                );
            }
            return flat;
        });


}

async function cetsPunchIn() {
    var now = new Date();
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ startDate: now, offset: now.getTimezoneOffset() })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/users/cetspunchin', requestOptions, true);
}



function convertBase64ToBinaryArray(base64) {
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (var i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
    }
    return array;
}

async function getNumPages(pdfData) {
    const pdf = await pdfjs.getDocument(pdfData).promise;
    return pdf.numPages;
}


